// src/pages/DSMPage.js
import React from 'react';
import Layout from '../components/Layout/Layout';
import syllabusPdf from '../images/syullubus.pdf';

const DSMPage = () => {
  return (
    <Layout>
      <div id="dsm" className="page-container" style={{ maxWidth: '1000px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        
        <h2 style={{ color: '#004d99', borderBottom: '2px solid #004d99', paddingBottom: '10px', marginBottom: '30px', textAlign: 'center', fontSize: '2.2rem', fontWeight: 'bold' }}>
          Commerce Departments Syllabus
        </h2>
        
        <div style={{ backgroundColor: '#fcfcfc', border: '1px solid #eee', borderLeft: '4px solid #1e5a95', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
          <iframe 
            src={syllabusPdf} 
            width="100%" 
            height="800px" 
            title="Commerce Departments Syllabus Document" 
            style={{ border: 'none', backgroundColor: '#333', borderRadius: '4px' }} 
          />
        </div>

      </div>
    </Layout>
  );
};

export default DSMPage;
